import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
import UpgradeModal from './UpgradeModal';
import './ContextualUpgradePrompt.css';

const MESSAGES = {
  projectLimit: {
    title: 'Need more projects?',
    description: 'Upgrade to premium for unlimited projects and more.',
  },
  areas: {
    title: 'Organize with Areas',
    description: 'Areas help you manage different aspects of your life. Unlock with premium.',
  },
  search: {
    title: 'Power up your search',
    description: 'Get advanced search filters and saved searches with premium.',
  },
};

export default function ContextualUpgradePrompt({ type, onDismiss }) {
  const [showUpgrade, setShowUpgrade] = useState(false);
  const message = MESSAGES[type];

  if (!message) return null;

  return (
    <>
      <div className="contextual-upgrade">
        <div className="contextual-upgrade-content" onClick={() => setShowUpgrade(true)}>
          <div className="contextual-upgrade-text">
            <strong>{message.title}</strong>
            <span>{message.description}</span>
          </div>
          <ArrowRight size={16} className="contextual-upgrade-arrow" />
        </div>
        {onDismiss && (
          <button className="contextual-upgrade-dismiss" onClick={onDismiss}>
            <X size={14} />
          </button>
        )}
      </div>
      {showUpgrade && (
        <UpgradeModal
          onClose={() => setShowUpgrade(false)}
          contextMessage={message.description}
        />
      )}
    </>
  );
}
